import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        d: "m14.156 5.512-4.43-.622-1.98-3.88a.322.322 0 0 0-.541 0l-1.98 3.88-4.431.622a.307.307 0 0 0-.151.066.282.282 0 0 0-.017.432l3.206 3.02-.757 4.265a.283.283 0 0 0 .12.285.308.308 0 0 0 .318.022l3.962-2.013 3.962 2.012a.31.31 0 0 0 .318-.022.293.293 0 0 0 .102-.126.282.282 0 0 0 .018-.16l-.757-4.263 3.206-3.02a.283.283 0 0 0-.016-.432.308.308 0 0 0-.152-.066Z",
        fill: "#64A4AC"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          transform: "translate(.234 .24)",
          d: "M0 0h14.483v14H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }